<template>
  <div
    class="nav-link"
    :class="{ 'nav-link--collapsed': collapsed }"
    role="button"
    tabindex="0"
    :title="collapsed ? title || label : undefined"
    @click="$emit('click', $event)"
    @keydown.enter.prevent="$emit('click', $event)"
    @keydown.space.prevent="$emit('click', $event)"
  >
    <app-icon
      :icon="navItem.icon"
      :gradient="navItem.gradient"
      size="xs"
    />
    <span class="nav-label" :class="{ 'nav-label--collapsed': collapsed }">{{ label }}</span>
  </div>
</template>

<script>
import AppIcon from '@/components/layout/AppIcon.vue';
import { getNavItemById } from '@/lib/appNavigation';

const FALLBACK_GRADIENT = 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))';

export default {
  name: 'navigation-action',
  components: {
    AppIcon,
  },
  props: {
    navId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    navItem() {
      const resolved = getNavItemById(this.navId);
      return {
        icon: resolved?.icon || 'fas fa-circle',
        gradient: resolved?.gradient || FALLBACK_GRADIENT,
      };
    },
  },
};
</script>
